// @ts-nocheck
import { chain, RequestDataFromApi } from "@insite/client-framework/Store/Data/ShipTos/Handlers/LoadShipTos";
import handleGetShipTosResult from "@store/Extensions/Store/Data/ShipTos/Handlers/handleGetShipTosResult";
import { addToChainAfter } from "@toolkit/Modules/client-framework/HandlerCreator";

addToChainAfter(chain, RequestDataFromApi, handleGetShipTosResult);
